import { ComponentProps } from "react";

import { omitClassNameFromProps } from "@/utils";
import { cn } from "@/utils/cn";

type PlateProps = {
  plate: string;
  color?: string;
  slots?: {
    wrapper?: ComponentProps<"div">;
    plate?: ComponentProps<"p">;
  };
};

export function Plate({ plate, color, slots = {} }: PlateProps) {
  return (
    <div
      className={cn(
        "text-red grid place-items-center overflow-hidden rounded-md border-2 border-current bg-white px-2 py-1 text-gray-700",
        { "max-w-36": false },
        slots?.wrapper?.className,
        color
      )}
      {...omitClassNameFromProps(slots?.wrapper || {})}
      style={{ color }}
    >
      <p className={cn("font-[Mercosul] text-3xl font-bold uppercase", slots?.plate?.className)} {...omitClassNameFromProps(slots?.plate || {})}>
        {plate}
      </p>
    </div>
  );
}
